//COINS
export const GET_COINS_LIST_REQUEST = "GET_COINS_LIST_REQUEST";
export const GET_COINS_LIST_SUCCESS = "GET_COINS_LIST_SUCCESS";
export const GET_COINS_LIST_ERROR = "GET_COINS_LIST_ERROR";

export const GET_TOKEN_INFO = "GET_TOKEN_INFO";
export const GET_COIN_XRATE = "GET_COIN_XRATE";
export const SHOW_COINS_LOADER = "SHOW_COINS_LOADER";
export const COINS_ERROR = "COINS_ERROR";
